import { Language } from "src/app/services/response-models/user.response.model";

export class SetLanguages {
    public static readonly type = "[App] Load languages";

    constructor(public payload: Language[]) {}
}
